module.exports = __webpack_public_path__ + "img/m-item02.fc20c2b.png";